export const VDataTableDefaultProps = {
  class: 'elevation-1 white',
  footerProps: {
    'items-per-page-options': [25, 50, 100, 250]
  },
  headerProps: {
    'sort-icon': 'fal fa-angle-up ml-2'
  },
  itemsPerPage: 25,
  mustSort: true
}
